import { convertUSDPriceToCurrency, formatPrice } from '../../utils/utils'

export const getReferralPrice = (currency: string) => {
  return currency
    ? formatPrice(Math.round(convertUSDPriceToCurrency(20, currency)), currency)
    : ''
}
